"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAddManualCommitmentRequestBodyToJSON = exports.AdminAddManualCommitmentRequestBodyFromJSONTyped = exports.AdminAddManualCommitmentRequestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminAddManualCommitmentRequestBodyFromJSON(json) {
    return AdminAddManualCommitmentRequestBodyFromJSONTyped(json, false);
}
exports.AdminAddManualCommitmentRequestBodyFromJSON = AdminAddManualCommitmentRequestBodyFromJSON;
function AdminAddManualCommitmentRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'commitmentAmountUsd': json['commitmentAmountUsd'],
        'sourceType': json['sourceType'],
        'specialTerms': json['specialTerms'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
    };
}
exports.AdminAddManualCommitmentRequestBodyFromJSONTyped = AdminAddManualCommitmentRequestBodyFromJSONTyped;
function AdminAddManualCommitmentRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'userEmail': value.userEmail,
        'commitmentAmountUsd': value.commitmentAmountUsd,
        'sourceType': value.sourceType,
        'specialTerms': value.specialTerms,
        'adminNotes': value.adminNotes,
    };
}
exports.AdminAddManualCommitmentRequestBodyToJSON = AdminAddManualCommitmentRequestBodyToJSON;
